import { MobileAppInstallService } from 'src/app/dmp/services/mobile-app-install.service';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { TooltipModule } from 'primeng/tooltip';
import { Component, AfterViewInit, OnInit, OnDestroy, ElementRef, ViewChild, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgModule, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TableComponentModule } from '../shared/ui/table.component'
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ToolbarModule } from 'primeng/toolbar';
import { TableModule } from 'primeng/table';
import { EnterpriseService } from 'src/app/dmp/services/enterprise.service';
import { ConfirmationService, MessageService, SharedModule, ConfirmEventType } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { SplitButtonModule } from 'primeng/splitbutton';
import { MessagesModule } from 'primeng/messages';
import { FieldsetModule } from 'primeng/fieldset';
import { QRCodeModule } from 'angularx-qrcode';
import { DmpCommonsComponent } from '../shared/dmp-commons/dmp-commons.component';
import { MessageBrokerService } from '../../../layout/service/message.broker.service'; // Adjust the path as needed
import { ToastModule } from 'primeng/toast';

declare const gapi: any;

// Define an interface for the product selection event
export interface ProductSelectionEvent {
  packageName: string; // e.g. "com.google.android.gm"
  productId: string;   // e.g. "app:com.google.android.gm"
  action: string;      // "approved", "unapproved" or "selected"
}

@Component({
  selector: 'app-mobile-app-install-managed-google-play',
  templateUrl: './mobile-app-install-managed-google-play.component.html',
  styleUrl: './mobile-app-install-managed-google-play.component.css',
  providers: [MessageService, ConfirmationService, EnterpriseService, DmpCommonsComponent, DialogModule, TooltipModule, MobileAppInstallService]

})

export class MobileAppInstallManagedGooglePlayComponent implements AfterViewInit, OnInit, OnDestroy {

  //#region constructor
  constructor( 
    private messageService: MessageService, 
    private activatedRoute: ActivatedRoute,
    private mobileAppInstallService: MobileAppInstallService,
    private enterpriseService: EnterpriseService,
    public dmpCommons: DmpCommonsComponent
  )
  { 
  }
  //#endregion
  
  //#region properties
  @ViewChild('googlePlayContainer') containerRef!: ElementRef;
  private scriptLoaded = false;
  selectedApp: ProductSelectionEvent | null = null;
  sessionIdToken: string = "";
  enterpriseId: string = "";
  deviceId: string = "";
  policyId: string = "";
  webtokenValue: string = "";
  messagesVisibility: string = "none";
  //#endregion

  ngOnInit() {
    console.log("InstallManagedGooglePlay.ngOnInit()");
    if (!this.dmpCommons.isAuthenticated()) {
      console.log("mobile-app-install-managed-google-play.component: not authenticated");
      return;
    }

    //#region params
    this.enterpriseId = this.activatedRoute.snapshot.paramMap.get('enterpriseId') ?? "";
    this.deviceId = this.activatedRoute.snapshot.paramMap.get('deviceId') ?? "";
    this.policyId = this.activatedRoute.snapshot.paramMap.get('policyId') ?? "";

    //console.log("mobile-app: this.enterpriseId: " + this.enterpriseId);
    //console.log("mobile-app: this.deviceId: " + this.deviceId);
    //console.log("mobile-app: this.policyId: " + this.policyId);

    //#endregion

    DmpCommonsComponent.userSessionIdToken().then((sessionIdToken: string) => {
      this.sessionIdToken = sessionIdToken;
    })

    this.loadManagedGooglePlay();
  }//end ngOnInit

  private loadManagedGooglePlay() {
    //Implementation reference
    DmpCommonsComponent.userSessionIdToken().then((sessionIdToken: any) => {

      this.enterpriseService.createWebToken(sessionIdToken, this.enterpriseId).subscribe({
        next: webTokenResponse => {
          //to-do: testar retorno de warn, err, info
          this.webtokenValue = webTokenResponse['data'];
          console.log("webTokenResponse: " + webTokenResponse);
          console.log("webTokenValue: " + this.webtokenValue);

          this.loadGapiScript(); //iframe
        },
        error: error => {
          // Handle error if needed
          console.error('Error creating webtoken to embed manage google play:', error);
          this.messagesVisibility = "block";
          this.messageService.add({ key: "permanentMessages", severity: 'error', detail: "Error loading google play" });
        }
      });

    }).catch(error => {
        ///this.emptyTableMessage = "Load failed, try again later...";
        console.error('Error fetching currentSession() to load google play:', error);
    });
  }//end createWebTokenValue

  ngAfterViewInit() {
    if (this.scriptLoaded) {
      this.initGooglePlayFrame();
    }
  }

  ngOnDestroy() {
    // Remove event listener when component is destroyed
    window.removeEventListener('resize', this.handleResize.bind(this));
  }

  private loadGapiScript() {
    const script = document.createElement('script');
    script.src = 'https://apis.google.com/js/api.js';
    script.async = true;
    script.defer = true;
    script.onload = () => {
      this.scriptLoaded = true;
      if (this.containerRef) {
        this.initGooglePlayFrame();
      }
    };
    document.body.appendChild(script);
  }

  private initGooglePlayFrame() {
    if (typeof gapi !== 'undefined') {
      
      gapi.load('gapi.iframes', () => {
        var urlWebtoken = this.webtokenValue;
        var managed_google_play_url = `https://play.google.com/work/embedded/search?token=${urlWebtoken}&mode=SELECT`;

        //managed_google_play_url = "http://wikipedia.org/wiki/Google_Play#Managed_Google_Play"; //for testing purposes
        
        // Calculate responsive dimensions based on container
        const containerWidth = '100%';
        const containerHeight = this.calculateHeight();
        
        const options = {
          'url': managed_google_play_url,
          'where': this.containerRef.nativeElement,
          'attributes': { 
            style: `width: ${containerWidth}; height: ${containerHeight}px; max-width: 100%;`, 
            scrolling: 'yes'
          }
        };

        const iframe = gapi.iframes.getContext().openChild(options);
        
        // Register event handler for product selection
        iframe.register('onproductselect', (product: ProductSelectionEvent) => {
          this.handleProductSelect(product);
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        
        // Add window resize listener to adjust iframe height
        window.addEventListener('resize', this.handleResize.bind(this));
      });
    }
  }
  
  private handleResize() {
    if (this.containerRef && this.containerRef.nativeElement) {
      const iframe = this.containerRef.nativeElement.querySelector('iframe');
      if (iframe) {
        iframe.style.height = `${this.calculateHeight()}px`;
      }
    }
  }
  
  private calculateHeight(): number {
    // Calculate a reasonable height based on viewport
    const viewportHeight = window.innerHeight;
    // Use 80% of viewport height or minimum of 600px
    return Math.max(Math.round(viewportHeight * 0.8), 600);
  }

  // Handle product selection from the Google Play iframe
  private handleProductSelect(product: ProductSelectionEvent): void {
    
    console.log('Item selected:', product);
    this.selectedApp = product;

    this.installAppService(this.deviceId, product.packageName);
  }

  private installAppService(deviceId: string, packageName: string) {
    this.messageService.clear("permanentMessages");

    console.log(`installAppService("${deviceId}", "${packageName}")`);

    DmpCommonsComponent.userSessionIdToken().then((sessionIdToken: any) => {
      //this.emptyTableMessage = "Loading...";

      //console.log(sessionIdToken); //to-do: remove this

      this.mobileAppInstallService.installGooglePlayApp(sessionIdToken, deviceId, packageName).subscribe({
        next: mobileAppInstallServiceResponse => {

          var successMessageSummary = `App "${packageName}" installed successfully`;
          var successMessageDetail = ``;
          var usePermanentMessage = true;

          let responseHasError = this.dmpCommons.handleResponseWithMessage(
            mobileAppInstallServiceResponse, 
            successMessageSummary, 
            successMessageDetail, 
            usePermanentMessage, 
            this.messageService);
          
          this.messagesVisibility = "block";
          if (!responseHasError) {
            console.log(`mobileAppInstallServiceResponse: "${mobileAppInstallServiceResponse}"`);
            console.log(`mobileAppInstallServiceResponse:`, mobileAppInstallServiceResponse);
          }

        },
        error: error => {
          // Handle error if needed
          console.error('Error installing app:', error);
          this.messagesVisibility = "block";
          this.messageService.add({ key: "permanentMessages", severity: 'error', detail: `Error installing app "${packageName}"` });
        }
      });

    }).catch(error => {
        this.messageService.add({ key: "permanentMessages", severity: 'error', detail: `Error fetching current session` });
        console.error('Error fetching current session:', error);
    });


  }//end installAppService

}//end class MobileAppInstallManagedGooglePlayComponent

@NgModule({
  declarations: [MobileAppInstallManagedGooglePlayComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    DividerModule,
    DialogModule,
    FormsModule,
    ToastModule,
    QRCodeModule,
    SharedModule,
    ToolbarModule,
    SplitButtonModule,
    TableModule,
    CommonModule,
    ButtonModule,
    MessagesModule,
    FieldsetModule,
    TableComponentModule,
    RouterModule.forChild([
        {
            path: '',
            component: MobileAppInstallManagedGooglePlayComponent,
        },
    ]),
    DmpCommonsComponent
],
})

export class MobileAppInstallManagedGooglePlayModule {}